import { Box, Container, Typography, Button } from "@mui/material";
import { Link } from "react-router-dom";
import { SearchOff } from "@mui/icons-material";
import { routes } from "../routes/routes";

const NotFoundPage = () => {
  return (
    <Container
      maxWidth="sm"
      sx={{
        height: "70vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <Box textAlign="center">
        <Box sx={{ mb: 2, color: "error.main" }}>
          <SearchOff sx={{ fontSize: 80 }} />
        </Box>
        <Typography variant="h3" fontWeight="bold" gutterBottom>
          Página no encontrada
        </Typography>
        <Typography variant="body1" mb={3}>
          La página que busca no existe.
        </Typography>
        <Button component={Link} to={routes.root} variant="contained" sx={{ mt: 2 }}>
          Volver al inicio
        </Button>
      </Box>
    </Container>
  );
};

export default NotFoundPage;
